import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import {ExamModule, UserModule} from '@cp/model';

export interface DeleteModuleDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  module: ExamModule | null;
  userModule: UserModule | null;
  loading?: boolean;
}

export default function DeleteModuleDialog({
  open,
  onClose,
  onConfirm,
  module,
  userModule,
  loading = false,
}: DeleteModuleDialogProps) {
  if (!module || !userModule) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Remove Module</DialogTitle>
      <DialogContent>
        <Box sx={{mb: 2}}>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to remove <strong>{module.name}</strong> from your selected modules?
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            This will remove all {(userModule.topics ?? []).length} selected topics for this module.
          </Typography>
        </Box>
        <Alert severity="warning" sx={{mt: 2}}>
          This action cannot be undone. You can always add this module back later if needed.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
          data-testid="confirm-delete-button"
        >
          Remove Module
        </Button>
      </DialogActions>
    </Dialog>
  );
}
